import { Text } from '@frontend/legacy-components';

const ValueText = ({ children, useDataFont = false }) => (
  <Text
    color="feature.primary"
    fontFamily={useDataFont ? 'data' : 'default'}
    fontSize="sm"
  >
    {children}
  </Text>
);

export default ValueText;
